export default __webpack_public_path__ + "static/media/placeholder_dummy2016-zahnarzt01-de.090b3001.png";